import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { CtaCard, Icon, type IconName } from '@carbonify/ui';
import CtaButton from 'components/CtaButton';

interface CtaCardBlockRecord extends CdaStructuredTextRecord {
  content: {
    icon?: { icon: IconName };
    title?: string;
    description?: string;
    cta?: string;
  };
}

export default function CtaCardBlock({ content: { title, description, cta, icon } }: CtaCardBlockRecord) {
  return (
    <CtaCard
      title={title}
      description={description}
      footer={
        cta && (
          <CtaButton
            variant="ghost"
            highlight
            size="xl"
            borderRadius="lg"
          >
            {cta}
          </CtaButton>
        )
      }
      icon={icon && <Icon name={icon} />}
    />
  );
}
